module.exports = __webpack_public_path__ + "static/img/2diamond-tag@3x.371c3632.png";